    <nz-upload
      [nzShowUploadList]="false"
      [nzAccept]="acceptTypes"
      [nzBeforeUpload]="beforeUpload"
    >
      <ng-content></ng-content>
    </nz-upload>

    <nz-modal
      [nzVisible]="isModalVisible()"
      (nzVisibleChange)="isModalVisible.set($event)"
      [nzTitle]="'account.modals.cropImage.title' | translate"
      (nzOnCancel)="handleCancel()"
      (nzOnOk)="handleConfirm()"
      [nzOkText]="'global.button.save' | translate"
      [nzMaskClosable]="false"
    >
      <div class="modal-body" *nzModalContent>
        <div class="cropper-container">
          <img #imgUpload [src]="imageUrl()" alt="Source image" />
        </div>

        <div class="controls">
          <div class="slider">
            <span>{{ 'account.modals.cropImage.zoom' | translate }}</span>
            <nz-slider
              [nzMin]="1"
              [nzMax]="5"
              [nzStep]="0.1"
              [ngModel]="zoomValue()"
              (ngModelChange)="onZoomChange($event)"
            ></nz-slider>
          </div>
          <div class="slider">
            <span>{{ 'account.modals.cropImage.rotate' | translate }}</span>
            <nz-slider
              [nzMin]="-180"
              [nzMax]="180"
              [nzStep]="1"
              [ngModel]="rotateValue()"
              (ngModelChange)="onRotateChange($event)"
            ></nz-slider>
          </div>
        </div>
      </div>
      <img [src]="uploadedImage()" alt="Source image" />
    </nz-modal>